import { SYMBOL_CHECK_MARK, SYMBOL_X } from "../constants/text-symbols";

const VALID_COLOR = /^#\w{6}$/;
/**
 * Returns either a valid HEX color, either null
 *
 * @returns {string|null}
 * @param colorValue color value must be a valid HEX color (e.g. #00FF34)
 */
export const formatColor = (colorValue) => {
  return colorValue && VALID_COLOR.test(colorValue) ? colorValue : null;
};
const RANDOM_DATE = "2025-03-29";
const DATE_DEFAULT_OPTIONS = {
  timeZone: "UTC",
};
const VALID_SQL_TIME_REGEX = /^[0-2]\d:[0-5]\d:[0-5]\d$/;
export const VALID_SQL_DATE_REGEX = /^\d{1,4}-[0-1]\d-[0-3]\d$/;
export const INVALID_ZERO_DATE = "0000-00-00";
export const INVALID_ZERO_DATE_TIME = "0000-00-00 00:00:00";
export const VALID_SQL_DATE_TIME_REGEX =
  /^\d{1,4}-[0-1]\d-[0-3]\d [0-2]\d:[0-5]\d:[0-5]\d$/;

/**
 * Returns a formatted date string
 *
 * @param dateValue date value must be a valid SQL date (e.g. 2025-03-29)
 * @param locale locale to format the date
 * @returns {string}
 */
export const formatDate = (dateValue, locale) => {
  return VALID_SQL_DATE_REGEX.test(dateValue) && dateValue !== INVALID_ZERO_DATE
    ? new Date(dateValue).toLocaleDateString(locale, DATE_DEFAULT_OPTIONS)
    : "";
};

/**
 * Returns a formatted time string
 *
 * @param dateValue time value must be a valid SQL time (e.g. 23:59:59)
 * @param locale locale to format the time
 * @returns {string}
 */
export const formatTime = (dateValue, locale) => {
  if (VALID_SQL_TIME_REGEX.test(dateValue)) {
    const currentDate = new Date(`${RANDOM_DATE} ${dateValue}Z`);
    return currentDate.toLocaleTimeString(locale, DATE_DEFAULT_OPTIONS);
  }

  return "";
};

/**
 * Returns a formatted boolean string, recognizable by the end user
 *
 * @param value boolean value must be either 1 or 0
 * @returns {string}
 */
export const formatBoolean = (value) => {
  switch (value) {
    case "1":
      return SYMBOL_CHECK_MARK;
    case "0":
      return SYMBOL_X;
    default:
      return "";
  }
};

/**
 * Returns a formatted date time string
 *
 * @param dateValue date time value must be a valid SQL date time (e.g. 2025-03-29 23:59:59)
 * @param locale locale to format the date time
 * @returns {string}
 */
export const formatDateTime = (dateValue, locale) => {
  if (
    VALID_SQL_DATE_TIME_REGEX.test(dateValue) &&
    dateValue !== INVALID_ZERO_DATE_TIME
  ) {
    const currentDate = new Date(`${dateValue}Z`);
    return (
      currentDate.toLocaleDateString(locale, DATE_DEFAULT_OPTIONS) +
      ", " +
      currentDate.toLocaleTimeString(locale, DATE_DEFAULT_OPTIONS)
    );
  }

  return "";
};
